import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import { getHumanUrl } from "../../utils";
import { getNotesMeta } from "../../selectors/notesMeta";
import Badge from "../../components/Badge";

const HumanMentions = React.memo(({ human, ...props }) => {
  const mentions = useSelector((state) => getNotesMeta(state)[0][human.id]);

  if (!mentions) {
    return null;
  }

  return (
    <div className="text-left flex flex-wrap items-center gap-1">
      <span className="text-sm text-gray-500 relative top-0.5">Mentions: </span>
      {mentions.map((h) => (
        <div key={h.id} className="inline mr-1">
          <Badge>
            <Link to={getHumanUrl(h)}>{h.name}</Link>
          </Badge>
        </div>
      ))}
    </div>
  );
});

HumanMentions.displayName = "HumanMentions";
HumanMentions.propTypes = {
  human: PropTypes.object.isRequired,
};
export default HumanMentions;
